export default "/kiban/_next/static/images/yes-c962584d852301c06eda68b90b7ef07c.png";